// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fgError .errorText {
  padding: 0 15px;
  top: calc(100% + 5px);
}

.fgError .errorIcon {
  left: 0;
  font-size: 0.89rem;
}

.fgError {
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/change-password/change-password.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,qBAAA;AACF;;AAEA;EACE,OAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF","sourcesContent":[".fgError .errorText {\r\n  padding: 0 15px;\r\n  top: calc(100% + 5px);\r\n}\r\n\r\n.fgError .errorIcon {\r\n  left: 0;\r\n  font-size: 0.89rem;\r\n}\r\n\r\n.fgError {\r\n  margin-bottom: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
